module.exports = __webpack_public_path__ + "images/d4fd425295262269e58d6bb8c4d69eff-IMG_6370.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_6370.jpg
// module id = ./src/assets/images/slides/living2/IMG_6370.jpg
// module chunks = 0